import React from 'react';
import { Container, Box } from '@mui/material';
import OPRARequestForm from './OPRARequestForm';

function PublicFormsPage() {
    return (
        <Container maxWidth="md">
            <Box sx={{ mt: 4, mb: 4 }}>
                <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
                    <Box component="img" src="/nhs-logo.png" alt="NHS" sx={{ height: 60 }} />
                </Box>
                <OPRARequestForm />
            </Box>
        </Container>
    );
}

export default PublicFormsPage;
